// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-skeleton {
  display: block;
  width: 90px;
  max-width: 100%;
  height: 12px;
  border-radius: 4px;
  background: linear-gradient(90deg, #edf1f6 25%, #f8fafd 50%, #edf1f6 75%);
  background-size: 200% 100%;
  animation: table-skeleton-shimmer 1.5s ease-in-out infinite;
}

.skeleton-row {
  height: 49px;
}
.skeleton-row td:nth-child(n+2):nth-child(-n+5) {
  min-width: 130px;
}
.skeleton-row td:nth-child(n+2):nth-child(-n+5) .table-skeleton {
  width: 130px;
}
.skeleton-row td:nth-child(8) .table-skeleton,
.skeleton-row td:nth-child(9) .table-skeleton {
  width: 75px;
  height: 20px;
  border-radius: 20px;
}
.skeleton-row td:last-child .table-skeleton {
  width: 24px;
  height: 24px;
  margin-inline: auto;
  border-radius: 6px;
}

@keyframes table-skeleton-shimmer {
  from {
    background-position: 200% 0;
  }
  to {
    background-position: -200% 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  .table-skeleton {
    animation: none;
  }
}
:host {
  display: block;
  container-type: inline-size;
  color: #253750;
  font-size: 12px;
  --mdc-outlined-text-field-container-shape: 7px;
}

.products-page {
  padding: 2px 0 8px;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 24px;
}

.header-left {
  min-width: 0;
}
.header-left h1 {
  margin: 0;
  color: #172b46;
  font-size: 22px;
  line-height: 30px;
  font-weight: 600;
}
.header-left p {
  margin: 6px 0 0;
  color: #7d8a9d;
  font-size: 12px;
  line-height: 19px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 35px;
  border: 1px solid #dce5ef;
  border-radius: 8px;
  padding: 7px 12px;
  font: inherit;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
}
.button span.material-symbols-outlined {
  display: block;
  font-size: 18px;
  line-height: 1;
}
.button .mdc-button__label {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}
.button.primary {
  background: var(--primary-color);
  border-color: var(--primary-color);
  color: white;
}
.button.primary:hover:not(:disabled) {
  background: var(--primary-color-hover);
}
.button.secondary {
  background: white;
  color: #53647a;
}
.button.secondary:hover, .button.secondary.selected {
  background: color-mix(in srgb, var(--primary-color) 5%, white);
  color: var(--primary-color);
  border-color: color-mix(in srgb, var(--primary-color) 25%, white);
}
.button:disabled {
  opacity: 0.45;
  cursor: default;
}
.button:focus-visible {
  outline: 2px solid color-mix(in srgb, var(--primary-color) 40%, white);
  outline-offset: 2px;
}

::ng-deep .products-page .button .mdc-button__label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
}

.filter-wrapper {
  position: relative;
}

.filter-dot {
  width: 5px;
  height: 5px;
  background: var(--primary-color);
  border-radius: 50%;
}

.filter-dropdown {
  position: absolute;
  z-index: 5;
  inset-inline-end: 0;
  top: calc(100% + 10px);
  width: 340px;
  max-width: calc(100vw - 64px);
  max-height: 75vh;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 18px;
  border: 1px solid #dce5ef;
  border-radius: 12px;
  box-shadow: 0 10px 35px rgba(23, 43, 70, 0.13);
  background: white;
}

.filter-heading h2 {
  font-size: 13px;
  font-weight: 600;
  margin: 0;
  line-height: 20px;
}
.filter-heading p {
  font-size: 11px;
  color: #7d8a9d;
  margin: 4px 0 14px;
}

.filter-label {
  display: block;
  color: #53647a;
  font-size: 11px;
  font-weight: 500;
  margin: 12px 0 6px;
}

.search-field {
  position: relative;
  display: flex;
  align-items: center;
}
.search-field span {
  position: absolute;
  inset-inline-start: 10px;
  color: #8a98ab;
  font-size: 17px;
}
.search-field input {
  padding-inline-start: 33px !important;
}

.filter-dropdown input:not([matInput]) {
  width: 100%;
  height: 36px;
  border: 1px solid #dce5ef;
  border-radius: 7px;
  background: white;
  color: #253750;
  padding: 0 10px;
  font: inherit;
  font-size: 11px;
  box-sizing: border-box;
}
.filter-dropdown input:not([matInput]):focus {
  outline: none;
  border-color: var(--primary-color);
}
.filter-dropdown input:not([matInput])::placeholder {
  color: #9aa8ba;
}

.status-field {
  width: 100%;
  font-size: 11px;
  --mat-form-field-container-text-size: 11px;
  --mat-select-trigger-text-size: 12px;
}

.date-fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.date-fields > div {
  min-width: 0;
}
.date-fields mat-form-field {
  width: 100%;
  font-size: 11px;
  --mat-form-field-container-vertical-padding: 8px;
  --mat-form-field-container-text-size: 11px;
  --mat-form-field-container-text-line-height: 18px;
  --mdc-outlined-text-field-outline-color: #dce5ef;
  --mdc-outlined-text-field-focus-outline-color: var(--primary-color);
  --mdc-outlined-text-field-hover-outline-color: color-mix(in srgb, var(--primary-color) 25%, white);
  --mat-icon-button-state-layer-size: 32px;
  --mat-datepicker-toggle-icon-size: 17px;
}

.filter-error {
  font-size: 11px;
  color: #c34242;
  line-height: 17px;
  margin: 8px 0 0;
}

.filter-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid #edf1f6;
}

::ng-deep .mat-mdc-menu-panel .mat-mdc-menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #35445b;
}
::ng-deep .mat-mdc-menu-panel .mat-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  color: inherit;
}
::ng-deep .mat-mdc-menu-panel .mat-mdc-menu-item .mdc-list-item__primary-text {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}
::ng-deep .mat-mdc-menu-panel .view-action mat-icon,
::ng-deep .mat-mdc-menu-panel .edit-action mat-icon,
::ng-deep .mat-mdc-menu-panel .preview-action mat-icon,
::ng-deep .mat-mdc-menu-panel .delete-action,
::ng-deep .mat-mdc-menu-panel .delete-action mat-icon {
  color: inherit;
}

.table-card {
  border: 1px solid #e2e9f2;
  border-radius: 12px;
  background: white;
  overflow: hidden;
}

.table-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 18px;
  border-bottom: 1px solid #edf1f6;
}
.table-heading h2 {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  line-height: 20px;
  font-weight: 600;
  margin: 0;
}
.table-heading h2 span {
  background: #f1f6fd;
  border-radius: 5px;
  padding: 1px 6px;
  color: #6480a4;
  font-size: 10px;
  font-weight: 500;
}

.text-button {
  border: 0;
  background: transparent;
  color: var(--primary-color);
  font: inherit;
  font-size: 11px;
  cursor: pointer;
  padding: 2px 0;
}

.table-scroll {
  overflow-x: auto;
  scrollbar-width: thin;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;
  text-align: start;
}

th {
  background: #fbfcfe;
  color: #7d8a9d;
  font-size: 10px;
  font-weight: 500;
  white-space: nowrap;
}

th,
td {
  padding: 12px 16px;
  text-align: start;
  border-bottom: 1px solid #edf1f6;
  vertical-align: middle;
}

tbody tr:last-child td {
  border-bottom: 0;
}

tbody tr:hover {
  background: #fcfdff;
}

.price-group-code {
  color: var(--primary-color);
  font-weight: 500;
  white-space: nowrap;
}

.name-column {
  min-width: 130px;
  max-width: 180px;
  line-height: 18px;
  overflow-wrap: anywhere;
}

td.name-column[lang=ar] {
  text-align: left;
}

.created-date {
  white-space: nowrap;
  color: #8491a3;
  font-size: 10px;
}

.status {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border-radius: 20px;
  padding: 3px 7px;
  background: #f1f3f7;
  color: #7d8a9d;
  font-size: 10px;
  white-space: nowrap;
}
.status > span {
  width: 4px;
  height: 4px;
  background: currentColor;
  border-radius: 50%;
}
.status.enabled {
  background: #eef7f2;
  color: #36866a;
}

.actions-column {
  text-align: center;
  width: 50px;
}

.row-menu-button {
  display: inline-grid;
  place-items: center;
  height: 28px;
  width: 28px;
  background: transparent;
  border: 0;
  border-radius: 6px;
  color: #8491a3;
  cursor: pointer;
}
.row-menu-button span {
  font-size: 20px;
}
.row-menu-button:hover, .row-menu-button:focus-visible {
  color: var(--primary-color);
  background: color-mix(in srgb, var(--primary-color) 9%, white);
  outline: none;
}

.action-icon {
  font-size: 18px;
  vertical-align: middle;
  margin-inline-end: 10px;
  color: #8491a3;
}

.delete-action {
  color: #c84343;
}
.delete-action .action-icon {
  color: inherit;
}

.empty-state {
  text-align: center;
  padding: 50px 20px;
}
.empty-state > span {
  font-size: 28px;
  color: #a9bad1;
}
.empty-state h3 {
  font-size: 13px;
  font-weight: 500;
  margin: 10px 0 4px;
}
.empty-state p {
  font-size: 11px;
  color: #8491a3;
  margin: 0;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@media (max-width: 1000px) {
  .page-header {
    align-items: flex-start;
    flex-direction: column;
    gap: 14px;
  }
  .header-right {
    position: relative;
    width: 100%;
    flex-wrap: wrap;
  }
  .filter-wrapper {
    position: static;
  }
  .filter-dropdown {
    inset-inline-start: 0;
    inset-inline-end: auto;
    max-width: 100%;
  }
}
@container (max-width: 700px) {
  .page-header {
    align-items: flex-start;
    flex-direction: column;
    gap: 14px;
  }
  .header-right {
    position: relative;
    width: 100%;
    flex-wrap: wrap;
  }
  .filter-wrapper {
    position: static;
  }
  .filter-dropdown {
    inset-inline-start: 0;
    inset-inline-end: auto;
    max-width: 100%;
  }
}
@media (max-width: 550px) {
  .header-left h1 {
    font-size: 20px;
  }
  .header-right {
    gap: 8px;
  }
  .button {
    font-size: 11px;
    padding: 7px 9px;
  }
  .filter-dropdown {
    width: 300px;
    padding: 14px;
  }
  .date-fields {
    grid-template-columns: 1fr;
    gap: 0;
  }
  th,
  td {
    padding: 10px 12px;
  }
}
.status.approved {
  background: #eef7f2;
  color: #36866a;
}

.status.rejected {
  background: #fff0f0;
  color: #c34242;
}

.status.pending {
  background: #fff7e6;
  color: #936300;
}

.load-error {
  color: #c34242;
  margin: 0 0 16px;
}

.sort-button {
  display: flex;
  align-items: center;
  gap: 6px;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  cursor: pointer;
  padding: 0;
  white-space: nowrap;
}

.sort-button .material-symbols-outlined {
  font-size: 15px;
  color: #8a98ab;
}

.product-cell {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 200px;
  max-width: 300px;
}

.product-cell img,
.image-placeholder {
  width: 36px;
  height: 36px;
  border-radius: 7px;
  object-fit: contain;
  background: #f7f9fc;
  flex-shrink: 0;
}

.image-placeholder {
  display: grid;
  place-items: center;
  font-size: 20px;
  color: #8a98ab;
}

.product-name {
  text-align: start;
  border: 0;
  background: transparent;
  color: #253750;
  font: inherit;
  font-weight: 500;
  cursor: pointer;
}

.product-name:hover {
  color: var(--primary-color);
}

.price-cell {
  white-space: nowrap;
}

.status.draft {
  color: #9a6700;
  background: #fff8e6;
}`, "",{"version":3,"sources":["webpack://./src/theme/table-skeleton.scss","webpack://./src/app/components/products-management/products-management.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,yEAAA;EACA,0BAAA;EACA,2DAAA;ACCF;;ADEA;EACE,YAAA;ACCF;ADAE;EAAwC,gBAAA;ACG1C;ADFE;EAAwD,YAAA;ACK1D;ADJE;;EACkC,WAAA;EAAa,YAAA;EAAc,mBAAA;ACS/D;ADRE;EAAgC,WAAA;EAAa,YAAA;EAAc,mBAAA;EAAqB,kBAAA;ACclF;;ADXA;EACE;IAAO,2BAAA;ECeP;EDdA;IAAK,4BAAA;ECiBL;AACF;ADfA;EACE;IAAkB,eAAA;ECkBlB;AACF;AA3CA;EACE,cAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,8CAAA;AA6CF;;AA1CA;EACE,kBAAA;AA6CF;;AA1CA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AA6CF;;AA1CA;EACE,YAAA;AA6CF;AA3CE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AA6CJ;AA1CE;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AA4CJ;;AAxCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AA2CF;;AAxCA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;AA2CF;AAzCE;EACE,cAAA;EACA,eAAA;EACA,cAAA;AA2CJ;AAxCE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AA0CJ;AAvCE;EACE,gCAAA;EACA,kCAAA;EACA,YAAA;AAyCJ;AAvCI;EACE,sCAAA;AAyCN;AArCE;EACE,iBAAA;EACA,cAAA;AAuCJ;AArCI;EAEE,8DAAA;EACA,2BAAA;EACA,iEAAA;AAsCN;AAlCE;EACE,aAAA;EACA,eAAA;AAoCJ;AAjCE;EACE,sEAAA;EACA,mBAAA;AAmCJ;;AA/BA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AAkCF;;AA/BA;EACE,kBAAA;AAkCF;;AA/BA;EACE,UAAA;EACA,WAAA;EACA,gCAAA;EACA,kBAAA;AAkCF;;AA/BA;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,8CAAA;EACA,iBAAA;AAkCF;;AA9BE;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;AAiCJ;AA9BE;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AAgCJ;;AA5BA;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AA+BF;;AA5BA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AA+BF;AA7BE;EACE,kBAAA;EACA,wBAAA;EACA,cAAA;EACA,eAAA;AA+BJ;AA5BE;EACE,qCAAA;AA8BJ;;AA1BA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;AA6BF;AA3BE;EACE,aAAA;EACA,kCAAA;AA6BJ;AA1BE;EACE,cAAA;AA4BJ;;AAxBA;EACE,WAAA;EACA,eAAA;EACA,0CAAA;EACA,oCAAA;AA2BF;;AAxBA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AA2BF;AAzBE;EACE,YAAA;AA2BJ;AAxBE;EACE,WAAA;EACA,eAAA;EACA,gDAAA;EACA,0CAAA;EACA,iDAAA;EACA,gDAAA;EACA,mEAAA;EACA,kGAAA;EACA,wCAAA;EACA,uCAAA;AA0BJ;;AAtBA;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;AAyBF;;AAtBA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AAyBF;;AArBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AAwBJ;AArBE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,cAAA;AAuBJ;AApBE;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;AAsBJ;AAnBE;;;;;EAKE,cAAA;AAqBJ;;AAjBA;EACE,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AAoBF;;AAjBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;AAoBF;AAlBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,SAAA;AAoBJ;AAlBI;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAoBN;;AAfA;EACE,SAAA;EACA,uBAAA;EACA,2BAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AAkBF;;AAfA;EACE,gBAAA;EACA,qBAAA;AAkBF;;AAfA;EACE,WAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;AAkBF;;AAfA;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAkBF;;AAfA;;EAEE,kBAAA;EACA,iBAAA;EACA,gCAAA;EACA,sBAAA;AAkBF;;AAfA;EACE,gBAAA;AAkBF;;AAfA;EACE,mBAAA;AAkBF;;AAfA;EACE,2BAAA;EACA,gBAAA;EACA,mBAAA;AAkBF;;AAfA;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AAkBF;;AAfA;EACE,gBAAA;AAkBF;;AAfA;EACE,mBAAA;EACA,cAAA;EACA,eAAA;AAkBF;;AAfA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;AAkBF;AAhBE;EACE,UAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;AAkBJ;AAfE;EACE,mBAAA;EACA,cAAA;AAiBJ;;AAbA;EACE,kBAAA;EACA,WAAA;AAgBF;;AAbA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAgBF;AAdE;EACE,eAAA;AAgBJ;AAbE;EAEE,2BAAA;EACA,8DAAA;EACA,aAAA;AAcJ;;AAVA;EACE,eAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;AAaF;;AAVA;EACE,cAAA;AAaF;AAXE;EACE,cAAA;AAaJ;;AATA;EACE,kBAAA;EACA,kBAAA;AAYF;AAVE;EACE,eAAA;EACA,cAAA;AAYJ;AATE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AAWJ;AARE;EACE,eAAA;EACA,cAAA;EACA,SAAA;AAUJ;;AANA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AASF;;AAmBA;EAxBE;IACE,uBAAA;IACA,sBAAA;IACA,SAAA;EASF;EALA;IACE,kBAAA;IACA,WAAA;IACA,eAAA;EAOF;EAJA;IACE,gBAAA;EAMF;EAHA;IACE,qBAAA;IACA,sBAAA;IACA,eAAA;EAKF;AACF;AAGA;EA7BE;IACE,uBAAA;IACA,sBAAA;IACA,SAAA;EA6BF;EAzBA;IACE,kBAAA;IACA,WAAA;IACA,eAAA;EA2BF;EAxBA;IACE,gBAAA;EA0BF;EAvBA;IACE,qBAAA;IACA,sBAAA;IACA,eAAA;EAyBF;AACF;AAbA;EACE;IACE,eAAA;EAeF;EAZA;IACE,QAAA;EAcF;EAXA;IACE,eAAA;IACA,gBAAA;EAaF;EAVA;IACE,YAAA;IACA,aAAA;EAYF;EATA;IACE,0BAAA;IACA,MAAA;EAWF;EARA;;IAEE,kBAAA;EAUF;AACF;AANA;EACE,mBAAA;EACA,cAAA;AAQF;;AALA;EACE,mBAAA;EACA,cAAA;AAQF;;AALA;EACE,mBAAA;EACA,cAAA;AAQF;;AALA;EACE,cAAA;EACA,gBAAA;AAQF;;AALA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,UAAA;EACA,mBAAA;AAQF;;AALA;EACE,eAAA;EACA,cAAA;AAQF;;AALA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AAQF;;AALA;;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;AAQF;;AALA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AAQF;;AALA;EACE,iBAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AAQF;;AALA;EACE,2BAAA;AAQF;;AALA;EACE,mBAAA;AAQF;;AALA;EACE,cAAA;EACA,mBAAA;AAQF","sourcesContent":[".table-skeleton {\n  display: block;\n  width: 90px;\n  max-width: 100%;\n  height: 12px;\n  border-radius: 4px;\n  background: linear-gradient(90deg, #edf1f6 25%, #f8fafd 50%, #edf1f6 75%);\n  background-size: 200% 100%;\n  animation: table-skeleton-shimmer 1.5s ease-in-out infinite;\n}\n\n.skeleton-row {\n  height: 49px;\n  td:nth-child(n + 2):nth-child(-n + 5) { min-width: 130px; }\n  td:nth-child(n + 2):nth-child(-n + 5) .table-skeleton { width: 130px; }\n  td:nth-child(8) .table-skeleton,\n  td:nth-child(9) .table-skeleton { width: 75px; height: 20px; border-radius: 20px; }\n  td:last-child .table-skeleton { width: 24px; height: 24px; margin-inline: auto; border-radius: 6px; }\n}\n\n@keyframes table-skeleton-shimmer {\n  from { background-position: 200% 0; }\n  to { background-position: -200% 0; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .table-skeleton { animation: none; }\n}\n","@import '../../../theme/table-skeleton';\n\n:host {\n  display: block;\n  container-type: inline-size;\n  color: #253750;\n  font-size: 12px;\n  --mdc-outlined-text-field-container-shape: 7px;\n}\n\n.products-page {\n  padding: 2px 0 8px;\n}\n\n.page-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  margin-bottom: 24px;\n}\n\n.header-left {\n  min-width: 0;\n\n  h1 {\n    margin: 0;\n    color: #172b46;\n    font-size: 22px;\n    line-height: 30px;\n    font-weight: 600;\n  }\n\n  p {\n    margin: 6px 0 0;\n    color: #7d8a9d;\n    font-size: 12px;\n    line-height: 19px;\n  }\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  min-height: 35px;\n  border: 1px solid #dce5ef;\n  border-radius: 8px;\n  padding: 7px 12px;\n  font: inherit;\n  font-size: 12px;\n  cursor: pointer;\n  white-space: nowrap;\n\n  span.material-symbols-outlined {\n    display: block;\n    font-size: 18px;\n    line-height: 1;\n  }\n\n  .mdc-button__label {\n    display: inline-flex;\n    align-items: center;\n    gap: 7px;\n  }\n\n  &.primary {\n    background: var(--primary-color);\n    border-color: var(--primary-color);\n    color: white;\n\n    &:hover:not(:disabled) {\n      background: var(--primary-color-hover);\n    }\n  }\n\n  &.secondary {\n    background: white;\n    color: #53647a;\n\n    &:hover,\n    &.selected {\n      background: color-mix(in srgb, var(--primary-color) 5%, white);\n      color: var(--primary-color);\n      border-color: color-mix(in srgb, var(--primary-color) 25%, white);\n    }\n  }\n\n  &:disabled {\n    opacity: .45;\n    cursor: default;\n  }\n\n  &:focus-visible {\n    outline: 2px solid color-mix(in srgb, var(--primary-color) 40%, white);\n    outline-offset: 2px;\n  }\n}\n\n::ng-deep .products-page .button .mdc-button__label {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n}\n\n.filter-wrapper {\n  position: relative;\n}\n\n.filter-dot {\n  width: 5px;\n  height: 5px;\n  background: var(--primary-color);\n  border-radius: 50%;\n}\n\n.filter-dropdown {\n  position: absolute;\n  z-index: 5;\n  inset-inline-end: 0;\n  top: calc(100% + 10px);\n  width: 340px;\n  max-width: calc(100vw - 64px);\n  max-height: 75vh;\n  overflow-y: auto;\n  box-sizing: border-box;\n  padding: 18px;\n  border: 1px solid #dce5ef;\n  border-radius: 12px;\n  box-shadow: 0 10px 35px rgba(23, 43, 70, .13);\n  background: white;\n}\n\n.filter-heading {\n  h2 {\n    font-size: 13px;\n    font-weight: 600;\n    margin: 0;\n    line-height: 20px;\n  }\n\n  p {\n    font-size: 11px;\n    color: #7d8a9d;\n    margin: 4px 0 14px;\n  }\n}\n\n.filter-label {\n  display: block;\n  color: #53647a;\n  font-size: 11px;\n  font-weight: 500;\n  margin: 12px 0 6px;\n}\n\n.search-field {\n  position: relative;\n  display: flex;\n  align-items: center;\n\n  span {\n    position: absolute;\n    inset-inline-start: 10px;\n    color: #8a98ab;\n    font-size: 17px;\n  }\n\n  input {\n    padding-inline-start: 33px !important;\n  }\n}\n\n.filter-dropdown input:not([matInput]) {\n  width: 100%;\n  height: 36px;\n  border: 1px solid #dce5ef;\n  border-radius: 7px;\n  background: white;\n  color: #253750;\n  padding: 0 10px;\n  font: inherit;\n  font-size: 11px;\n  box-sizing: border-box;\n\n  &:focus {\n    outline: none;\n    border-color: var(--primary-color);\n  }\n\n  &::placeholder {\n    color: #9aa8ba;\n  }\n}\n\n.status-field {\n  width: 100%;\n  font-size: 11px;\n  --mat-form-field-container-text-size: 11px;\n  --mat-select-trigger-text-size: 12px;\n}\n\n.date-fields {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n\n  >div {\n    min-width: 0;\n  }\n\n  mat-form-field {\n    width: 100%;\n    font-size: 11px;\n    --mat-form-field-container-vertical-padding: 8px;\n    --mat-form-field-container-text-size: 11px;\n    --mat-form-field-container-text-line-height: 18px;\n    --mdc-outlined-text-field-outline-color: #dce5ef;\n    --mdc-outlined-text-field-focus-outline-color: var(--primary-color);\n    --mdc-outlined-text-field-hover-outline-color: color-mix(in srgb, var(--primary-color) 25%, white);\n    --mat-icon-button-state-layer-size: 32px;\n    --mat-datepicker-toggle-icon-size: 17px;\n  }\n}\n\n.filter-error {\n  font-size: 11px;\n  color: #c34242;\n  line-height: 17px;\n  margin: 8px 0 0;\n}\n\n.filter-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 18px;\n  padding-top: 14px;\n  border-top: 1px solid #edf1f6;\n}\n\n::ng-deep .mat-mdc-menu-panel {\n  .mat-mdc-menu-item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    color: #35445b;\n  }\n\n  .mat-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0;\n    color: inherit;\n  }\n\n  .mat-mdc-menu-item .mdc-list-item__primary-text {\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n  }\n\n  .view-action mat-icon,\n  .edit-action mat-icon,\n  .preview-action mat-icon,\n  .delete-action,\n  .delete-action mat-icon {\n    color: inherit;\n  }\n}\n\n.table-card {\n  border: 1px solid #e2e9f2;\n  border-radius: 12px;\n  background: white;\n  overflow: hidden;\n}\n\n.table-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 18px;\n  border-bottom: 1px solid #edf1f6;\n\n  h2 {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 13px;\n    line-height: 20px;\n    font-weight: 600;\n    margin: 0;\n\n    span {\n      background: #f1f6fd;\n      border-radius: 5px;\n      padding: 1px 6px;\n      color: #6480a4;\n      font-size: 10px;\n      font-weight: 500;\n    }\n  }\n}\n\n.text-button {\n  border: 0;\n  background: transparent;\n  color: var(--primary-color);\n  font: inherit;\n  font-size: 11px;\n  cursor: pointer;\n  padding: 2px 0;\n}\n\n.table-scroll {\n  overflow-x: auto;\n  scrollbar-width: thin;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 11px;\n  text-align: start;\n}\n\nth {\n  background: #fbfcfe;\n  color: #7d8a9d;\n  font-size: 10px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\nth,\ntd {\n  padding: 12px 16px;\n  text-align: start;\n  border-bottom: 1px solid #edf1f6;\n  vertical-align: middle;\n}\n\ntbody tr:last-child td {\n  border-bottom: 0;\n}\n\ntbody tr:hover {\n  background: #fcfdff;\n}\n\n.price-group-code {\n  color: var(--primary-color);\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.name-column {\n  min-width: 130px;\n  max-width: 180px;\n  line-height: 18px;\n  overflow-wrap: anywhere;\n}\n\ntd.name-column[lang='ar'] {\n  text-align: left;\n}\n\n.created-date {\n  white-space: nowrap;\n  color: #8491a3;\n  font-size: 10px;\n}\n\n.status {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  border-radius: 20px;\n  padding: 3px 7px;\n  background: #f1f3f7;\n  color: #7d8a9d;\n  font-size: 10px;\n  white-space: nowrap;\n\n  >span {\n    width: 4px;\n    height: 4px;\n    background: currentColor;\n    border-radius: 50%;\n  }\n\n  &.enabled {\n    background: #eef7f2;\n    color: #36866a;\n  }\n}\n\n.actions-column {\n  text-align: center;\n  width: 50px;\n}\n\n.row-menu-button {\n  display: inline-grid;\n  place-items: center;\n  height: 28px;\n  width: 28px;\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  color: #8491a3;\n  cursor: pointer;\n\n  span {\n    font-size: 20px;\n  }\n\n  &:hover,\n  &:focus-visible {\n    color: var(--primary-color);\n    background: color-mix(in srgb, var(--primary-color) 9%, white);\n    outline: none;\n  }\n}\n\n.action-icon {\n  font-size: 18px;\n  vertical-align: middle;\n  margin-inline-end: 10px;\n  color: #8491a3;\n}\n\n.delete-action {\n  color: #c84343;\n\n  .action-icon {\n    color: inherit;\n  }\n}\n\n.empty-state {\n  text-align: center;\n  padding: 50px 20px;\n\n  >span {\n    font-size: 28px;\n    color: #a9bad1;\n  }\n\n  h3 {\n    font-size: 13px;\n    font-weight: 500;\n    margin: 10px 0 4px;\n  }\n\n  p {\n    font-size: 11px;\n    color: #8491a3;\n    margin: 0;\n  }\n}\n\n.visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n@mixin stacked-header {\n  .page-header {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 14px;\n  }\n\n  // Position the panel within the content row rather than the narrow trigger.\n  .header-right {\n    position: relative;\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .filter-wrapper {\n    position: static;\n  }\n\n  .filter-dropdown {\n    inset-inline-start: 0;\n    inset-inline-end: auto;\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 1000px) {\n  @include stacked-header;\n}\n\n// Account for the space occupied by the sidebar, even on wider viewports.\n@container (max-width: 700px) {\n  @include stacked-header;\n}\n\n@media (max-width: 550px) {\n  .header-left h1 {\n    font-size: 20px;\n  }\n\n  .header-right {\n    gap: 8px;\n  }\n\n  .button {\n    font-size: 11px;\n    padding: 7px 9px;\n  }\n\n  .filter-dropdown {\n    width: 300px;\n    padding: 14px;\n  }\n\n  .date-fields {\n    grid-template-columns: 1fr;\n    gap: 0;\n  }\n\n  th,\n  td {\n    padding: 10px 12px;\n  }\n}\n\n\n.status.approved {\n  background: #eef7f2;\n  color: #36866a;\n}\n\n.status.rejected {\n  background: #fff0f0;\n  color: #c34242;\n}\n\n.status.pending {\n  background: #fff7e6;\n  color: #936300;\n}\n\n.load-error {\n  color: #c34242;\n  margin: 0 0 16px;\n}\n\n.sort-button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  cursor: pointer;\n  padding: 0;\n  white-space: nowrap;\n}\n\n.sort-button .material-symbols-outlined {\n  font-size: 15px;\n  color: #8a98ab;\n}\n\n.product-cell {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 200px;\n  max-width: 300px;\n}\n\n.product-cell img,\n.image-placeholder {\n  width: 36px;\n  height: 36px;\n  border-radius: 7px;\n  object-fit: contain;\n  background: #f7f9fc;\n  flex-shrink: 0;\n}\n\n.image-placeholder {\n  display: grid;\n  place-items: center;\n  font-size: 20px;\n  color: #8a98ab;\n}\n\n.product-name {\n  text-align: start;\n  border: 0;\n  background: transparent;\n  color: #253750;\n  font: inherit;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.product-name:hover {\n  color: var(--primary-color);\n}\n\n.price-cell {\n  white-space: nowrap;\n}\n\n.status.draft {\n  color: #9a6700;\n  background: #fff8e6;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
